import { promises as fs } from 'fs';
import path from 'path';
import { Component } from 'react';
import 'reflect-metadata';
import { resolveComponent } from '../../components/route-to-component-map';
import { RouteProps } from '../../types/route-types';

async function getAllFilePaths(postsDirectory: string, urlSet: Set<string>) {
    const paths = await fs.readdir(postsDirectory);
    for (const _path of paths) {
        const fullPath = path.join(postsDirectory, _path);
        const stats = await fs.stat(fullPath);
        if (stats.isDirectory()) {
            getAllFilePaths(fullPath, urlSet);
        } else {
            urlSet.add(fullPath);
        }
    }
}

export async function getStaticPaths() {
    const postsDirectory = path.join(process.cwd(), '/ssr-data/build/product/')
    const allFilePaths = new Set<string>();
    await getAllFilePaths(postsDirectory, allFilePaths);
    const allowedPaths = [
        new RegExp('product.*', 'i'),
    ];
    const disallowedList = [
        /root/i,
        /test/i,
        /invalid-path/i
    ];
    const filterFn = (urlPath: string, matchers: RegExp[]) => {
        return matchers.find(p => urlPath.match(p));
    };


    const paths = Array.from(allFilePaths)
        .filter(p => filterFn(p, allowedPaths))
        .filter(p => !filterFn(p, disallowedList))
        .map(path => {
            const urlPath = path.replace(postsDirectory, '').replace('.json', '');
            return { params: { product: urlPath.replace('product/', '') } };
        });

    console.log(paths);
    return {
        paths:
            paths,
        fallback: false // See the "fallback" section below
    };
}

export async function getStaticProps({ params }) {
    const props = path.join(process.cwd(), `/ssr-data/build/product/${params.product}.json`);
    const data = await fs.readFile(props);
    const jObj = JSON.parse(data.toString());
    // Pass post data to the page via props
    // We need to inject path here
    jObj.path = '/product/' + params.product;
    return { props: jObj };
}

export default class ProductPage extends Component<RouteProps> {

    constructor(props) {
        super(props);
    }

    render() {
        const Comp = resolveComponent(this.props.path);
        return <Comp key={this.props.path} {...this.props}></Comp>;
    }
}